// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../startOfDecade/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var startOfDecade = convertToFP(fn, 1);
export default startOfDecade;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/startOfDecade/index.js
// module id = 987
// module chunks = 0